import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchWholesaleCollections = createAsyncThunk(
  "api/WholesaleCollections/fetch",
  async (params, thunkAPI) => {
    try {
      const {
        fromDate,
        toDate,
        partner_ids = [],
        group_by = "all",
        valueType = "collections",
        viewType = "all",
      } = params;
      const requestData = {
        fromdate: fromDate,
        todate: toDate,
        partner_ids,
        group_by,
        valueType,
        viewType,
      };

      const response = await api.post(`/api/WholesaleCollections`, requestData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const wholesaleCollectionsSlice = createSlice({
  name: "WholesaleCollections",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWholesaleCollections.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWholesaleCollections.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload;
      })
      .addCase(fetchWholesaleCollections.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default wholesaleCollectionsSlice.reducer;

// Selectors
export const selectWholesaleCollectionsRows = (state) => state.WholesaleCollections.rows;
export const selectWholesaleCollectionsStatus = (state) => state.WholesaleCollections.status;
export const selectWholesaleCollectionsError = (state) => state.WholesaleCollections.error;

